<template>
    <div>
        <!-- Auslöser unter dem Auswahlfeld — dieselbe Stelle und dieselbe
             Gestaltung wie «+ Kontaktperson hinzufügen» im ContactPicker
             darunter (Entscheid Peter, 31.08.2026). -->
        <div v-if="!showCreate" class="mt-2">
            <button
                type="button"
                class="text-sm text-minplan-blue hover:underline"
                @click="showCreate = true"
            >
                + {{ $t("suppliers.addSupplier") }}
            </button>
        </div>

        <div
            v-if="showCreate"
            class="mt-2 p-4 rounded-lg bg-minplan-beige/40 border border-minplan-darkbeige/30"
        >
            <p class="text-sm font-medium text-gray-700 mb-3">
                {{ $t("suppliers.newSupplier") }}
            </p>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div class="sm:col-span-2">
                    <label class="block text-xs font-medium text-gray-600">
                        {{ $t("suppliers.name") }} <RequiredMark />
                    </label>
                    <input type="text" v-model="neu.name" class="mt-1 block w-full text-sm border-gray-300 rounded shadow-sm focus:ring-minplan-blue focus:border-minplan-blue" />
                    <jet-input-error :message="fehler['name']?.[0]" class="mt-1" />
                </div>

                <div class="sm:col-span-2">
                    <label class="block text-xs font-medium text-gray-600">
                        {{ $t("suppliers.website") }}
                    </label>
                    <input type="text" v-model="neu.website" class="mt-1 block w-full text-sm border-gray-300 rounded shadow-sm focus:ring-minplan-blue focus:border-minplan-blue" />
                    <jet-input-error :message="fehler['website']?.[0]" class="mt-1" />
                </div>

                <div class="sm:col-span-2">
                    <label class="block text-xs font-medium text-gray-600">
                        {{ $t("suppliers.street") }} <RequiredMark />
                    </label>
                    <input type="text" v-model="neu.location.street" class="mt-1 block w-full text-sm border-gray-300 rounded shadow-sm focus:ring-minplan-blue focus:border-minplan-blue" />
                    <jet-input-error :message="fehler['location.street']?.[0]" class="mt-1" />
                </div>

                <div>
                    <label class="block text-xs font-medium text-gray-600">
                        {{ $t("suppliers.zip") }} <RequiredMark />
                    </label>
                    <input type="text" v-model="neu.location.zip" class="mt-1 block w-full text-sm border-gray-300 rounded shadow-sm focus:ring-minplan-blue focus:border-minplan-blue" />
                    <jet-input-error :message="fehler['location.zip']?.[0]" class="mt-1" />
                </div>

                <div>
                    <label class="block text-xs font-medium text-gray-600">
                        {{ $t("suppliers.city") }} <RequiredMark />
                    </label>
                    <input type="text" v-model="neu.location.city" class="mt-1 block w-full text-sm border-gray-300 rounded shadow-sm focus:ring-minplan-blue focus:border-minplan-blue" />
                    <jet-input-error :message="fehler['location.city']?.[0]" class="mt-1" />
                </div>

                <div class="sm:col-span-2">
                    <label class="block text-xs font-medium text-gray-600">
                        {{ $t("suppliers.country") }} <RequiredMark />
                    </label>
                    <Dropdown
                        v-model="neu.location.country"
                        :options="countries"
                        optionValue="code"
                        optionLabel="name"
                        filter
                        :placeholder="$t('suppliers.chooseCountry')"
                        class="w-full mt-1 sm:text-sm"
                    />
                    <jet-input-error :message="fehler['location.country']?.[0]" class="mt-1" />
                </div>

                <!-- Kontaktperson FREIWILLIG (Entscheid Peter, 31.08.2026):
                     wer sie noch nicht kennt, legt den Unternehmer trotzdem an
                     und ergänzt sie später über «+ Kontaktperson hinzufügen».
                     Sobald EIN Feld gefüllt ist, verlangt der Server alle vier
                     (`StoreSupplierInlineRequest`). -->
                <div class="sm:col-span-2 mt-1 pt-3 border-t border-minplan-darkbeige/30">
                    <p class="text-xs uppercase tracking-wide text-gray-500">
                        {{ $t("suppliers.contactPerson") }}
                        <span class="normal-case tracking-normal text-gray-400">
                            ({{ $t("suppliers.supplierOptional") }})
                        </span>
                    </p>
                </div>

                <div>
                    <label class="block text-xs font-medium text-gray-600">
                        {{ $t("suppliers.firstname") }}
                    </label>
                    <input type="text" v-model="neu.contact.firstname" class="mt-1 block w-full text-sm border-gray-300 rounded shadow-sm focus:ring-minplan-blue focus:border-minplan-blue" />
                    <jet-input-error :message="fehler['contact.firstname']?.[0]" class="mt-1" />
                </div>

                <div>
                    <label class="block text-xs font-medium text-gray-600">
                        {{ $t("suppliers.lastname") }}
                    </label>
                    <input type="text" v-model="neu.contact.lastname" class="mt-1 block w-full text-sm border-gray-300 rounded shadow-sm focus:ring-minplan-blue focus:border-minplan-blue" />
                    <jet-input-error :message="fehler['contact.lastname']?.[0]" class="mt-1" />
                </div>

                <div>
                    <label class="block text-xs font-medium text-gray-600">
                        {{ $t("suppliers.email") }}
                    </label>
                    <input type="email" v-model="neu.contact.email" class="mt-1 block w-full text-sm border-gray-300 rounded shadow-sm focus:ring-minplan-blue focus:border-minplan-blue" />
                    <jet-input-error :message="fehler['contact.email']?.[0]" class="mt-1" />
                </div>

                <div>
                    <label class="block text-xs font-medium text-gray-600">
                        {{ $t("suppliers.phone") }}
                    </label>
                    <input type="text" v-model="neu.contact.mobile" class="mt-1 block w-full text-sm border-gray-300 rounded shadow-sm focus:ring-minplan-blue focus:border-minplan-blue" />
                    <jet-input-error :message="fehler['contact.mobile']?.[0]" class="mt-1" />
                </div>
            </div>

            <p v-if="unerwarteterFehler" class="mt-3 text-xs text-red-600">
                {{ $t("actions.defaultError") }}
            </p>

            <div class="mt-4 flex justify-end gap-3">
                <button
                    type="button"
                    class="text-xs uppercase tracking-widest font-semibold"
                    @click="abbrechen"
                >
                    {{ $t("actions.cancel") }}
                </button>
                <button
                    type="button"
                    class="inline-flex items-center py-2 px-4 text-xs uppercase tracking-widest font-semibold text-white bg-minplan-greybeige hover:bg-minplan-lightgreybeige disabled:opacity-40"
                    :disabled="speichert"
                    @click="anlegen"
                >
                    {{ $t("actions.add") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import axios from "axios";
import JetInputError from "@/Jetstream/InputError.vue";
import RequiredMark from "@/Shared/Components/RequiredMark.vue";
import { countries } from "@/Shared/countries";

/**
 * Unternehmer direkt aus der Themen-/Offerten-Maske anlegen (Entscheid Peter,
 * 31.08.2026). Aufbau bewusst wie `ContactPicker.vue`: Auslöser unter dem
 * Auswahlfeld, beiges Formular darunter, `axios`-POST ohne Inertia-Neuladen —
 * die Maske behält damit alle bereits erfassten Eingaben.
 *
 * Der neue Unternehmer wird nach oben gemeldet (`created`), damit die Maske ihn
 * in ihre Auswahlliste aufnehmen und gleich auswählen kann.
 */
export default defineComponent({
    components: { JetInputError, RequiredMark },
    emits: ["created"],
    data() {
        return {
            // Eine Quelle für die ganze App (`Shared/countries.js`) — die
            // Liste stand vorher sechsmal wörtlich im Code.
            countries,
            showCreate: false,
            speichert: false,
            unerwarteterFehler: false,
            fehler: {},
            neu: this.leeresFormular(),
        };
    },
    methods: {
        leeresFormular() {
            return {
                name: "",
                website: "",
                location: { street: "", zip: "", city: "", country: "CH" },
                contact: { firstname: "", lastname: "", email: "", mobile: "" },
            };
        },
        abbrechen() {
            this.showCreate = false;
            this.fehler = {};
            this.unerwarteterFehler = false;
            this.neu = this.leeresFormular();
        },
        anlegen() {
            if (this.speichert) {
                return;
            }

            this.speichert = true;
            this.fehler = {};
            this.unerwarteterFehler = false;

            axios
                .post(this.route("advisors.suppliers.store.inline"), this.neu)
                .then(({ data }) => {
                    this.$emit("created", data.supplier);
                    this.abbrechen();
                })
                .catch((error) => {
                    if (error.response?.status === 422) {
                        this.fehler = error.response.data.errors ?? {};
                        return;
                    }

                    this.unerwarteterFehler = true;
                })
                .finally(() => {
                    this.speichert = false;
                });
        },
    },
});
</script>
